export default "__VITE_ASSET__29ea55f1__"